module.exports = __webpack_public_path__ + "img/seleccion-multiple.a8f096d7.svg";